import React, {Component} from 'react';
import {gpn} from "../GPN"
import Icon from "./MUI/Icon";
import Modal from "./MUI/Modal";
import Logo from "../assets/images/logo.png";
import {toast} from "react-toastify";
import config from "../config";
import NoPerson from "../assets/images/no-person.jpg";

const menuItems = [
    {t: "درباره ما", i: "users", v: "/about"},
    {t: "تماس با ما", i: "user-headset", v: "/contact"},
    {t: "سایت تکین آنوش", i: "external-link", v: "https://takinanoosh.ir"},
    {t: "سایت نظیفچی", i: "external-link", v: "https://nazifchi.ir"}
]

class Header extends Component {

    state = {
        modalMenu: false
    };

    render() {
        let path = document.location.pathname;
        let {title = ""} = this.props;
        let phone = "";
        let name = "";
        let authVideoStatus = "none";
        let profilePhoto = "";
        title = String(title || "").trim();
        try {
            if (path.startsWith("/login")) return null;
        } catch (err) {
        }
        if (this.props.info) {
            phone = this.props.info.phone;
            name = this.props.info.fullName;
            try {
                authVideoStatus = this.props.info.authVideoStatus;
            } catch (err) {
            }
            try {
                profilePhoto = `${config.api}/user/profile-photo?token=${config.token}`;
            } catch (err) {
            }
        }
        let {modalMenu} = this.state;
        return (
            <header id="header">
                <Modal display={modalMenu}
                       onCloseClick={() => this.setState({modalMenu: false})}>
                    <div className="modal-menu">

                        <div className="logo">
                            <img src={profilePhoto === "" ? Logo : profilePhoto} alt="قسطی تک" draggable={false}/>
                        </div>

                        <div className="phone">{phone}</div>
                        {name !== "" ?
                            <div className="name">{name}</div> : null
                        }
                        {
                            menuItems.map((m, i) =>
                                <div className="menu-item"
                                     key={"menu" + i}
                                     onClick={() => {
                                         this.setState({modalMenu: false});
                                         if (m.v.includes("https")) {
                                             try {
                                                 if (window) {
                                                     window.open(m.v, "_blank");
                                                 } else {
                                                     document.location.href = m.v;
                                                 }
                                             } catch (err) {
                                             }
                                         } else {
                                             this.props.navigate(m.v);
                                         }
                                     }}>
                                    <div className="row justify-content-between">
                                        <div className="col-auto">
                                            <Icon i={m.i}/>
                                        </div>
                                        <div className="col">
                                            <span className="title">{m.t}</span>
                                        </div>

                                    </div>
                                </div>
                            )
                        }
                        <div className="menu-item" onClick={() => {
                            toast.info("در حال خروج از حساب کاربری ...");
                            try {
                                localStorage.removeItem("token");
                                localStorage.removeItem("chats");
                                if ('serviceWorker' in navigator) {
                                    caches.keys().then((cacheNames) => {
                                        cacheNames.forEach((cacheName) => {
                                            caches.delete(cacheName);
                                        });
                                    });
                                }
                            } catch (err) {
                            }
                            setTimeout(() => {
                                document.location.href = "/login";
                            }, 3000);
                        }}>
                            <div className="row justify-content-between">
                                <div className="col-auto">
                                    <Icon i="sign-out-alt"/>
                                </div>
                                <div className="col">
                                    <span className="title">خروج از حساب کاربری</span>
                                </div>

                            </div>
                        </div>
                    </div>
                </Modal>
                <div className="row">
                    <div className="col-auto">
                        {
                            path === "/" ?
                                <Icon i="bars" className="icon"
                                      onClick={() => this.setState({modalMenu: true})}/>
                                :
                                path !== "/login" ?
                                    <Icon i="arrow-right" className="icon"
                                          onClick={() => this.props.navigate(-1)}/>
                                    : null
                        }

                    </div>
                    <div className="col">
                        <div className="title">{title ? title : "قسطی تک"}</div>
                    </div>
                </div>
                <div className="user-header">
                    <div className="row">
                        <div className="col-auto">
                            <div className="profile-photo-header">
                                <img draggable={false}
                                     onError={e => e.currentTarget.src = NoPerson}
                                     src={profilePhoto !== "" ? profilePhoto : NoPerson} alt=""/>
                            </div>
                        </div>
                        <div className="col">
                            <div className="full-name">{name === "" ? "کاربر مهمان" : name}</div>
                            <div className="phone-number">{phone}</div>
                        </div>
                        <div className="col-auto">
                            <div className="auth-video">
                                <div className="t">«احراز هویت»</div>
                                {authVideoStatus.toLowerCase() !== "verified" ?
                                    <>
                                        <Icon i="close" solid style={{backgroundColor: "#c62929"}}/>
                                    </>
                                    :
                                    <>
                                        <Icon i="check" solid style={{backgroundColor: "#1a9c11"}}/>
                                    </>
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}

export default gpn(Header);